import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.closeHandler = this.closeOnClickOutside.bind(this);
    this.keyHandler = this.closeOnEscape.bind(this);
  }

  toggle(event) {
    event.stopPropagation();

    // Close all other dropdowns first
    document
      .querySelectorAll("[data-controller~='dropdown']")
      .forEach((dropdown) => {
        if (dropdown !== this.element) {
          const controller =
            this.application.getControllerForElementAndIdentifier(
              dropdown,
              "dropdown",
            );
          if (
            controller &&
            !controller.menuTarget.classList.contains("hidden")
          ) {
            controller.close();
          }
        }
      });

    if (this.menuTarget.classList.contains("hidden")) {
      this.open(event);
    } else {
      this.close();
    }
  }

  open(event) {
    // Position the menu using fixed positioning
    const button = event.currentTarget;
    const rect = button.getBoundingClientRect();

    this.menuTarget.classList.remove("hidden");

    // Use fixed positioning to escape overflow containers
    this.menuTarget.style.position = "fixed";
    this.menuTarget.style.top = `${rect.bottom + 4}px`; // 4px gap (mt-1)
    this.menuTarget.style.left = `${rect.right - 192}px`; // 192px = w-48, align right edge

    this.element
      .querySelector("[data-action*='dropdown#toggle']")
      ?.setAttribute("aria-expanded", "true");
    document.addEventListener("click", this.closeHandler);
    document.addEventListener("keydown", this.keyHandler);
  }

  close() {
    this.menuTarget.classList.add("hidden");
    this.menuTarget.style.position = "";
    this.menuTarget.style.top = "";
    this.menuTarget.style.left = "";

    this.element
      .querySelector("[data-action*='dropdown#toggle']")
      ?.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", this.closeHandler);
    document.removeEventListener("keydown", this.keyHandler);
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  disconnect() {
    document.removeEventListener("click", this.closeHandler);
    document.removeEventListener("keydown", this.keyHandler);
  }
}
